function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.61929 0 1.5 1.11929 1.5 2.5C1.5 3.88071 2.61929 5 4 5C5.38071 5 6.5 3.88071 6.5 2.5C6.5 1.11929 5.38071 0 4 0ZM2.5 2.5C2.5 1.67157 3.17157 1 4 1C4.82843 1 5.5 1.67157 5.5 2.5C5.5 3.32843 4.82843 4 4 4C3.17157 4 2.5 3.32843 2.5 2.5Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6C1.83696 6 1.20107 6.26339 0.732233 6.73223C0.263392 7.20107 0 7.83696 0 8.5V9.5C0 9.77614 0.223858 10 0.5 10C0.776142 10 1 9.77614 1 9.5V8.5C1 8.10217 1.15804 7.72064 1.43934 7.43934C1.72064 7.15804 2.10218 7 2.5 7H5.5C5.89782 7 6.27936 7.15804 6.56066 7.43934C6.84196 7.72064 7 8.10218 7 8.5V9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5V8.5C8 7.83696 7.73661 7.20107 7.26777 6.73223C6.79893 6.26339 6.16304 6 5.5 6H2.5Z",
    fill: "#292726",
    style: {
      fill: "#292726",
      fill: "color(display-p3 0.1608 0.1529 0.1490)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.ca7754eb1ea20016ac261cf53387936c.svg";
export { ForwardRef as ReactComponent };